jQuery(function($){
  $(document).ready(function($) {
    function toggleButtons() {
      setTimeout(function() {
        var iinVal = ($('#iin').inputmask('unmaskedvalue') || '');
        var phoneVal = ($('#phone').inputmask('unmaskedvalue') || '');
        var valid = iinVal.length >= 10 && phoneVal.length >= 10;
        $('.submit-btn').prop('disabled', !valid);
      }, 0);
    }

    $('#phone').inputmask({
      mask: '+7 (999) 999-99-99',
      placeholder: '_',
      clearIncomplete: true,
      showMaskOnHover: true,
      onBeforePaste: function (pastedValue, opts) {
          var processedValue = pastedValue.replace(/\D/g, '');
          if (processedValue.startsWith('7') || processedValue.startsWith('8')) {
              processedValue = processedValue.substring(1);
          }
          return processedValue;
      }
    });

    $('#iin').inputmask({
      mask: '9999999999[99]',
      placeholder: '',
      greedy: false,
      clearIncomplete: true,
    });

    $(document).on('input keyup paste', '#iin, #phone', toggleButtons);

    $('#success-modal .modal-button, #success-modal .modal-close').click(function() {
      $('#success-modal').removeClass('active');
    });
  
    $('.submit-btn').click(function(e) {
      e.preventDefault();
      
      // Определяем какая кнопка нажата
      var buttonType = $(this).data('button-type');
      $('#button_type').val(buttonType);
      
      // Собираем данные формы
      var formData = $('#restructuring-form').serialize();
      
      // Отправляем AJAX запрос
      $.ajax({
        url: my_ajax_object.ajax_url, // Переменная из wp_localize_script
        type: 'POST',
        data: {
          action: 'send_restructuring_request',
          form_data: formData,
          security: my_ajax_object.nonce
        },
        success: function(response) {
          $('#success-modal').addClass('active');
        },
        error: function() {
          console.log('Произошла ошибка при отправке');
        }
      });
    });
  });
})